import { Serie } from "../../../types/Serie";
import { NextPage, NextPageContext } from "next";
import { notAuthorised } from "../../../request";
import Header from "../../../components/Header";
import { getCommonData } from "../../../helpers/common-data";
import { CommonData } from "../../../types/CommonData";
import Footer from "../../../components/Footer";
import { BlocksRenderer } from "../../../components/BlocksRenderer";
import { InPageMenu } from "../../../components/InPageMenu";

import { Announcement } from "../../../types/Announcement";
import { getAnnouncements } from "../../../helpers/getAnnouncements";
import { getRichSnippet } from "../../../helpers/rich-snippets/series";
import { getFrontendUrl } from "../../../helpers/utils";
import { SEOTags } from "../../../components/SEOTags";
import Error from "../../_error";
import { useEffect } from "react";
import { OpenSeries } from "../../../components/OpenSeries";
import gtm from "helpers/gtm";

export const SerieDetail: NextPage<{
  data: Serie | null;
  commonData: CommonData;
  announcements: Announcement[];
}> = (props) => {
  const data = props.data;

  useEffect(() => {
    function configureOlark() {
      if (typeof window.olark === "undefined") return;
      window.olark("api.box.hide");
    }

    gtm.viewSerie(data);
    setTimeout(() => configureOlark());
  }, [data]);

  if (!data) {
    return (
      <Error
        commonData={props.commonData}
        announcements={props.announcements}
        statusCode={404}
      />
    );
  }

  const blocks = data.blocks;

  return (
    <>
      <SEOTags
        title={data.name}
        description={data.description}
        keywords={data.keywords}
        url={getFrontendUrl(`/series/${data.slug}`)}
        featuredImage={data.featured_image}
        richSnippets={getRichSnippet(data)}
        noIndex={data.visibility === "PRIVATE"}
      />
      <Header
        headerStyle={data.header_style}
        announcements={props.announcements}
      />
      <article>
        <BlocksRenderer
          blocks={blocks}
          afterFirstBlock={
            <InPageMenu
              menu={data.menu}
              name={data.menu ? data.menu.name : ""}
            />
          }
        />
      </article>
      <OpenSeries slug={data.slug} />
      <Footer />
    </>
  );
};

interface Context extends NextPageContext {
  query: {
    slug: string;
  };
}

SerieDetail.getInitialProps = async (ctx: Context) => {
  if (ctx.res && ctx.query.slug === "tsavo-trust") {
    ctx.res.writeHead(301, {
      Location: `/tsavo-trust`,
    });

    ctx.res.end();

    return {} as any;
  }

  let data = null;

  try {
    const response = await notAuthorised.request<Serie>({
      method: "GET",
      url: `/api/frontend/series/${ctx.query.slug}/`,
    });

    data = response.data;
  } catch (error) {
    if (ctx.res) {
      ctx.res.statusCode = error.response.status;
    }
  }

  if (ctx.res && data && data.visibility === "ARCHIVED") {
    ctx.res.writeHead(301, {
      Location: `/retired-series`,
    });

    ctx.res.end();

    return {} as any;
  }

  const commonData = await getCommonData(ctx.req);
  const announcements = await getAnnouncements("SHOP");

  return {
    data: data,
    commonData: commonData,
    announcements,
  };
};
export default SerieDetail;
